function round2(n: number): number {
  return Math.round(n * 100) / 100;
}

/**
 * Build an SVG path `d` string (polyline) from a series of values,
 * normalized to the given viewBox width/height.
 */
export function sparklinePath(values: number[], w = 100, h = 24, pad = 2): string {
  if (values.length === 0) return '';
  const max = Math.max(...values, 1);
  const stepX = values.length > 1 ? (w - pad * 2) / (values.length - 1) : 0;
  return values
    .map((v, i) => {
      const x = pad + i * stepX;
      const y = h - pad - (v / max) * (h - pad * 2);
      return `${i === 0 ? 'M' : 'L'}${round2(x)},${round2(y)}`;
    })
    .join(' ');
}

/** Same polyline closed down to the baseline, for a translucent area fill. */
export function sparklineAreaPath(values: number[], w = 100, h = 24, pad = 2): string {
  const line = sparklinePath(values, w, h, pad);
  if (!line) return '';
  const stepX = values.length > 1 ? (w - pad * 2) / (values.length - 1) : 0;
  const lastX = round2(pad + (values.length - 1) * stepX);
  return `${line} L${lastX},${h - pad} L${pad},${h - pad} Z`;
}
